import blue from "./blue.jsx";
import red from "./red.jsx";
import wood from "./wood.jsx";
import metal from "./metal.jsx";

export default {
  blue,
  red,
  wood,
  metal,
};
